import { ConfigProvider } from "antd";
import { inevitable } from "./theme";
import { PropsWithChildren } from "react";

export const ThemeProvider = ({ children }: PropsWithChildren) =>
	<ConfigProvider theme={inevitable}>{children}</ConfigProvider>;
